<template>
    <VJoyInput
        v-model="r$.freelancerListName.$value"
        :label="$t('customer.freelancer.pof.modal.create.list.input.name')"
        :invalid="r$.freelancerListName.$error"
        name="freelancer-list-name"
        data-testid="freelancer-list-name"
    />

    <VJoyFormError v-if="r$.freelancerListName.$error" :errors="r$.$errors.freelancerListName" class="error" />

    <VJoyLabel>
        <VJoyIcon name="users" />
        {{ $t('customer.freelancer.pof.modal.create.list.collaborative.label') }}
    </VJoyLabel>

    <VJoyToggle
        v-model="r$.sharedWithinCompany.$value"
        :label="$t('customer.freelancer.pof.modal.create.list.collaborative.toggle.collaboration')"
        data-testid="freelancer-list-shared-toggle"
    />
</template>

<script setup lang="ts">
    import {required} from '@regle/rules';
    import {useRegle, validateForm} from '@malt/forms';
    import {VJoyFormError, VJoyInput, VJoyLabel, VJoyToggle, VJoyIcon} from '@maltjoy/core-vue';
    import type {FreelancersList} from '@api';

    const props = defineProps<{
        freelancerList?: FreelancersList;
    }>();

    type FormState = {
        freelancerListName: string;
        sharedWithinCompany: boolean;
    };

    const formDefaults: FormState = {
        freelancerListName: props.freelancerList?.name ?? '',
        sharedWithinCompany: props.freelancerList?.sharedWithinCompany ?? false,
    };

    const {r$} = useRegle(
        {...formDefaults},
        {
            freelancerListName: {required},
        },
    );

    function resetForm() {
        r$.$reset({toInitialState: true});
    }

    async function isFormInvalid(): Promise<boolean> {
        const {valid} = await validateForm(r$);
        return !valid;
    }

    function getValues(): FormState {
        return r$.$value;
    }

    defineExpose({
        getValues,
        resetForm,
        isFormInvalid,
    });
</script>
